import { parse } from "date-fns";

/**
 *
 * @param value yyyyMMdd
 * @returns string
 */

function parseDate(value = "") {
  return value.length
    ? parse(value, "dd/MM/yyyy", new Date()).toISOString()
    : null;
}

export default parseDate;
